module.exports = __webpack_public_path__ + "static/media/request.6b6f15bb.PNG";